import axios from 'axios';
import authService from './authService';
import { API_BASE_URL } from './apiConfig';

const API = API_BASE_URL;

class FundingService {
  getHeaders() {
    return {
      Authorization: `Bearer ${authService.getAccessToken()}`,
      'Content-Type': 'application/json'
    };
  }

  async getParticipateSummary() {
    const response = await axios.get(`${API}/participate/summary`, {
      headers: this.getHeaders()
    });
    return response.data;
  }

  async searchBooks(query = '') {
    const response = await axios.get(`${API}/participate/books/search`, {
      params: { q: query },
      headers: this.getHeaders()
    });
    return response.data;
  }

  async getBookDetail(bookId) {
    const response = await axios.get(`${API}/participate/books/${bookId}/detail`, {
      headers: this.getHeaders()
    });
    return response.data;
  }

  async getNarrators(bookId = null) {
    const params = bookId ? { book_id: bookId } : {};
    const response = await axios.get(`${API}/narrators`, {
      params,
      headers: this.getHeaders()
    });
    return response.data;
  }

  async createContribution(contributionData) {
    const response = await axios.post(
      `${API}/participate/contributions/create`,
      contributionData,
      { headers: this.getHeaders() }
    );
    return response.data;
  }

  async createInquiry(inquiryData) {
    const response = await axios.post(
      `${API}/participate/inquiries`,
      inquiryData,
      { headers: this.getHeaders() }
    );
    return response.data;
  }

  async mockCompletePayment(contributionId) {
    const response = await axios.post(
      `${API}/payment/mock-complete`,
      null,
      {
        params: { contribution_id: contributionId },
        headers: this.getHeaders()
      }
    );
    return response.data;
  }
}

export default new FundingService();
